import React, { useEffect, useRef, useState } from 'react'
import { observer } from 'mobx-react'
import { useEnvValue } from '@morningtrain/react-helpers'

function ViabillPrice ({ price, selectedQuantity }) {
  const fullAmountRef = useRef(null)
  const [fullAmount, setFullAmount] = useState(0)

  const [addConsulting] = useEnvValue('planting.addConsulting', false)
  const [consultingPrice] = useEnvValue('planting.consultPrice', 0)
  const [plantingPrice] = useEnvValue('planting.price', 0)

  useEffect(() => {
    let _fullAmount = 0
    if (! isNaN(selectedQuantity) && selectedQuantity !== 0) {
      _fullAmount = price * selectedQuantity
      _fullAmount += plantingPrice
      if (addConsulting) {
        _fullAmount += consultingPrice
      }
    }

    setFullAmount(_fullAmount)

    fullAmountRef.current.dispatchEvent(
      new Event("change", {
        detail: {
          newValue: _fullAmount,
        },
        bubbles: true,
        cancelable: true,
      })
    )
  }, [selectedQuantity, plantingPrice, addConsulting, consultingPrice, price])

  return (<input type={'hidden'} id={'full-amount'} ref={fullAmountRef} value={fullAmount} />)
}

ViabillPrice.defaultProps = {
  price: 0,
  selectedQuantity: 0
}

export default observer(ViabillPrice)